const Selector = {
    popperID: 'virtualPopper',
    popperHeader: '.popover-header',
    popperBody: '.popover-body'
}

function generateGetBoundingClientRect(x = 0, y = 0) {
    return () => ({
        width: 0,
        height: 0,
        top: y,
        right: x,
        bottom: y,
        left: x,
    });
}

export function renderVirtualPopper(elements) {
    import('@popperjs/core').then((module) => {
        const popper = document.getElementById(Selector.popperID)
        const popperHeader = popper.querySelector(Selector.popperHeader)
        const popperBody = popper.querySelector(Selector.popperBody)
        const virtualElement = {
            getBoundingClientRect: generateGetBoundingClientRect(),
        };
        const instance = module.createPopper(virtualElement, popper, {
            placement: 'auto',
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [0, 15],
                    },
                },
            ]
        });
        elements.forEach((el) => {
            el.addEventListener('mousemove', ({clientX: x, clientY: y}) => {
                popper.classList.remove('invisible')
                virtualElement.getBoundingClientRect = generateGetBoundingClientRect(x, y);
                popperBody.classList.remove('p-0')
                if (el.dataset.virtualPopperContent) {
                    popperHeader.classList.remove('d-none')
                    popperHeader.textContent = el.dataset.virtualPopperTitle || ''
                    if (el.dataset.virtualPopperHtml === "true") {
                        popperBody.innerHTML = el.dataset.virtualPopperContent
                    } else {
                        popperBody.textContent = el.dataset.virtualPopperContent
                    }

                } else {
                    popperHeader.classList.add('d-none')
                    popperBody.textContent = el.dataset.virtualPopperTitle || ''
                }
                instance.update();
            });

            ['mouseleave', 'mouseout', 'focusout'].forEach((eventName) => {
                el.addEventListener(eventName, () => {
                    popper.classList.add('invisible')
                });
            })
            document.addEventListener('scroll', (e) => {
                popper.classList.add('invisible')
            })
        })
    })
}